/**
 * Limit error handling for API client
 * This is separate from the React context to avoid Fast Refresh issues
 */

export interface LimitError {
  limitType: string;
  message: string;
  currentUsage?: number;
  limit?: number;
}

// Singleton for API client access (since it can't use hooks)
let limitErrorHandler: ((error: LimitError) => void) | null = null;

export function setLimitErrorHandler(handler: (error: LimitError) => void) {
  limitErrorHandler = handler;
}

export function triggerLimitError(error: LimitError) {
  if (limitErrorHandler) {
    limitErrorHandler(error);
  }
}
